export default __webpack_public_path__ + "static/media/logo.e88df916.png";